import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap";
import { Box, Typography } from "@mui/material";
import NotificationBell from "../../../components/common/NotificationBell";
import { API } from "../../../api/axios";

const DirectorProfilePage = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    if (userId) {
      fetchProfileData();
    } else {
      setError("User ID not found");
      setLoading(false);
    }
  }, [userId]);

  const fetchProfileData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Try multiple endpoints
      let response;
      try {
        response = await API.get(`/user/getUser/${userId}`);
      } catch (err) {
        // Fallback endpoint
        response = await API.get(`/user/profile/${userId}`);
      }

      if (response?.data) {
        setProfileData(response.data);
      } else {
        setError("No profile data received");
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
      setError(err?.response?.data?.message || "Failed to load profile data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Profile Header with Notification */}
      <Box sx={{ backgroundColor: "#f5f5f5", py: 2, mb: 3, borderBottom: "1px solid #e0e0e0" }}>
        <Container fluid>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Director Profile
            </Typography>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <NotificationBell />
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Profile Content */}
      <Container className="py-5">
        {loading ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography>Loading profile...</Typography>
          </Box>
        ) : error ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
            <Button
              variant="primary"
              onClick={fetchProfileData}
              className="btn-sm"
            >
              Retry
            </Button>
          </Box>
        ) : profileData ? (
          <Row>
            <Col md={8}>
              <Card className="mb-4">
                <Card.Header>
                  <Typography variant="h6" sx={{ fontWeight: 600, m: 0 }}>
                    Profile Information
                  </Typography>
                </Card.Header>
                <Card.Body>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={profileData?.firstName || ""}
                        disabled
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={profileData?.lastName || ""}
                        disabled
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Company Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={profileData?.companyName || ""}
                        disabled
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        value={profileData?.email || ""}
                        disabled
                      />
                    </Form.Group>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card>
                <Card.Header>
                  <Typography variant="h6" sx={{ fontWeight: 600, m: 0 }}>
                    Profile Summary
                  </Typography>
                </Card.Header>
                <Card.Body>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>User ID:</strong> {profileData?.id || userId}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Role:</strong> {profileData?.role || "Director"}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Status:</strong> Active
                  </Typography>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        ) : (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography>No profile data available</Typography>
          </Box>
        )}
      </Container>
    </>
  );
};

export default DirectorProfilePage;
